import { render } from "./success-alert.vue?vue&type=template&id=a9625422&scoped=true"
import script from "./success-alert.vue?vue&type=script&lang=js"
export * from "./success-alert.vue?vue&type=script&lang=js"

import "./success-alert.vue?vue&type=style&index=0&id=a9625422&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9625422"

export default script